import { Campaign } from "@vviinn/user-managment-client-ts";

export const calculateAssignedCategories = (campaign?: Campaign) => {
  if (!campaign || !campaign.linkedCategories || campaign?.type === "VPD")
    return {
      sourceCategoriesAmount: 0,
      targetCategoriesAmount: 0,
      categoriesAmount: 0,
    };
  const source = campaign?.linkedCategories?.source;
  const target = campaign?.linkedCategories?.target;

  const sourceGoogleCategoriesAmount =
    source?.googleFeedCategories?.length ?? 0;
  const sourceProductTypeCategoriesAmount =
    source?.productTypeCategories?.length ?? 0;
  const sourceCategoriesAmount =
    sourceGoogleCategoriesAmount + sourceProductTypeCategoriesAmount;

  const targetGoogleCategoriesAmount =
    target?.googleFeedCategories?.length ?? 0;
  const targetProductTypeCategoriesAmount =
    target?.productTypeCategories?.length ?? 0;
  const targetCategoriesAmount =
    targetGoogleCategoriesAmount + targetProductTypeCategoriesAmount;

  const categoriesAmount = sourceCategoriesAmount + targetCategoriesAmount;

  return { sourceCategoriesAmount, targetCategoriesAmount, categoriesAmount };
};
